import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, TextArea, Label, Message } from 'semantic-ui-react'


import FileInput from '../../components/FileInput/FileInput'
import { gradeSheetLink } from '../../utils/gradeSheetLink';

class GradesApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: '',
      levelHeadNotes: '',
      registrarNotes: '',
      principalNotes: '',
      discardNotes: '',
      error: false,
      errorDiscard: false,
      modalOpen: false,
      paceConfirm: null,
      pendingSubmission: null
    };
  }

  /**
   * A descriptive subject is approved on five summary letters, but those letters
   * summarise a couple of hundred competency ratings. Give the approvers a way
   * to actually look at them.
   */
  renderPaceLink = () => {
    if (!this.props.paceUrl) return null
    return (
      <div className='grades-pace-link'>
        <strong>PACE form: </strong>
        <a href={this.props.paceUrl}>
          <Icon name='list alternate outline' />
          View the competency ratings behind these letters
        </a>
        <br/>
        <br/>
      </div>
    )
  }

  /**
   * Descriptive subjects carry a PACE form behind their summary letters, so
   * warn before sending a half-filled one up the ladder.
   *
   * Deliberately a warning and not a block: a blank slot means the teacher has
   * not reached that competency yet, which is a legitimate state to end a term
   * in, and some rows currently offer more macro skills than the printed form
   * actually assesses. Blocking on either would stop valid submissions.
   */
  submitWithPaceCheck = (data, id) => {
    if (!this.props.onCheckPaceProgress) {
      return this.props.handleUpdateSectionSubjectDetails(data, id);
    }

    Promise.resolve(this.props.onCheckPaceProgress())
      // A failed count must not block a submission that is otherwise valid.
      // The catch belongs to the count, not to the submission - chained after
      // the .then below it would re-run a submission that threw.
      .catch(() => null)
      .then((progress) => {
        if (progress && progress.filled < progress.total) {
          this.setState({ paceConfirm: progress, pendingSubmission: { data, id } });
        } else {
          this.props.handleUpdateSectionSubjectDetails(data, id);
        }
      });
  }

  handleCancelPaceConfirm = () => this.setState({ paceConfirm: null, pendingSubmission: null })

  handleConfirmPaceSubmit = () => {
    const pending = this.state.pendingSubmission;
    this.setState({ paceConfirm: null, pendingSubmission: null }, () => {
      if (pending) this.props.handleUpdateSectionSubjectDetails(pending.data, pending.id);
    });
  }

  handleOpenDiscard = () => this.setState({ modalOpen: true })

  handleCloseDiscard = () => this.setState({ modalOpen: false, errorDiscard: false })

  handleClose = () => {
    this.setState({ error: false }, this.props.handleApprovalClose())
  }

  handleResubmit = () => {
    const id = this.props.sectionSubjectDetail.sectionSubjectDetailId;
    let data;
    const count = this.props.sectionSubjectDetail.resubmitCount;

    data = {
      status: 'Resubmit',
      resubmitCount: count ? parseInt(count, 10) + 1 : 1,
    }

    this.props.handleUpdateSectionSubjectDetails(data,id);
  }

  handleUpdate = () => {
    const id = this.props.sectionSubjectDetail.sectionSubjectDetailId;
    const status = this.props.sectionSubjectDetail.status;
    let data;

    if(status === 'To Do' || status === 'Discarded') {
      if (this.state.notes === '' || this.props.fileName === '') {
        this.setState({ error: true });
      } else {
        data = {
          notes: this.state.notes,
          createdDate: new Date(),
          createdBy: this.props.username,
          file: this.props.fileName,
          discardNotes: '',
          discardDate: undefined,
          discardBy: '',
          status: 'Created'
        }
        this.submitWithPaceCheck(data, id);
      }
    } else if (status === 'Created') {
      if (this.state.levelHeadNotes === '') {
        this.setState({ error: true });
      } else {
        data = {
          levelHeadNotes: this.state.levelHeadNotes,
          checkedDate: new Date(),
          checkedBy: this.props.username,
          status: 'Checked'
        }
        this.props.handleUpdateSectionSubjectDetails(data,id);
      }

    } else if (status === 'Checked') {
      if (this.state.registrarNotes === '') {
        this.setState({ error: true });
      } else {
        data = {
          registrarNotes: this.state.registrarNotes,
          reviewedDate: new Date(),
          reviewedBy: this.props.username,
          status: 'Reviewed'
        }
        this.props.handleUpdateSectionSubjectDetails(data,id);
      }
    } else if (status === 'Reviewed') {
      if (this.state.principalNotes === '') {
        this.setState({ error: true });
      } else {
        data = {
          principalNotes: this.state.principalNotes,
          approvedDate: new Date(),
          approvedBy: this.props.username,
          status: 'Approved'
        }
        this.props.handleUpdateSectionSubjectDetails(data,id);
      }
    } else if (status === 'Resubmit') {
      if (this.state.notes === '' || this.props.fileName === '') {
        this.setState({ error: true });
      } else {
        const count = this.props.sectionSubjectDetail.resubmitCount;
        if (count === 1) {
          data = {
            resubmitNotes: this.state.notes,
            resubmitDate: new Date(),
            resubmitBy: this.props.username,
            resubmitFile: this.props.fileName,
            status: 'Created'
          }
          this.submitWithPaceCheck(data, id);
        } else if (count === 2) {
          data = {
            resubmitNotes2: this.state.notes,
            resubmitDate2: new Date(),
            resubmitBy2: this.props.username,
            resubmitFile2: this.props.fileName,
            status: 'Created'
          }
          this.submitWithPaceCheck(data, id);
        } else if (count === 3) {
          data = {
            resubmitNotes3: this.state.notes,
            resubmitDate3: new Date(),
            resubmitBy3: this.props.username,
            resubmitFile3: this.props.fileName,
            status: 'Created'
          }
          this.submitWithPaceCheck(data, id);
        } else {
          alert("You can no longer resubmit the grades. Please contact your administrator.")
        }
      }

    }
  }

  handleDiscard = () => {
    const id = this.props.sectionSubjectDetail.sectionSubjectDetailId;
    const status = this.props.sectionSubjectDetail.status;
    let data;

    if (status === 'Created') {
      if (this.state.discardNotes === '') {
        this.setState({ errorDiscard: true });
      } else {
        data = {
          notes: '',
          file: '',
          createdDate: undefined,
          createdBy: '',
          discardNotes: this.state.discardNotes,
          discardDate: new Date(),
          discardBy: this.props.username,
          resubmitCount: undefined,
          resubmitBy: '',
          resubmitNotes: '',
          resubmitFile: '',
          resubmitDate: undefined,
          resubmitBy2: '',
          resubmitNotes2: '',
          resubmitFile2: '',
          resubmitDate2: undefined,
          resubmitBy3: '',
          resubmitNotes3: '',
          resubmitFile3: '',
          resubmitDate3: undefined,
          status: 'Discarded'
        }
        this.props.handleUpdateSectionSubjectDetails(data,id);
      }
    } else if (status === 'Checked') {
      if (this.state.discardNotes === '') {
        this.setState({ errorDiscard: true });
      } else {
        data = {
          notes: '',
          file: '',
          createdDate: undefined,
          createdBy: '',
          registrarNotes: '',
          reviewedDate: undefined,
          reviewedBy: '',
          discardNotes: this.state.discardNotes,
          discardDate: new Date(),
          discardBy: this.props.username,
          resubmitCount: undefined,
          resubmitBy: '',
          resubmitNotes: '',
          resubmitFile: '',
          resubmitDate: undefined,
          resubmitBy2: '',
          resubmitNotes2: '',
          resubmitFile2: '',
          resubmitDate2: undefined,
          resubmitBy3: '',
          resubmitNotes3: '',
          resubmitFile3: '',
          resubmitDate3: undefined,
          status: 'Discarded'
        }
        this.props.handleUpdateSectionSubjectDetails(data,id);
      }
    } else if (status === 'Reviewed') {
      if (this.state.discardNotes === '') {
        this.setState({ errorDiscard: true });
      } else {
        data = {
          notes: '',
          file: '',
          createdDate: undefined,
          createdBy: '',
          registrarNotes: '',
          reviewedDate: undefined,
          reviewedBy: '',
          principalNotes: '',
          approvedDate: undefined,
          approvedBy: '',
          discardNotes: this.state.discardNotes,
          discardDate: new Date(),
          discardBy: this.props.username,
          resubmitCount: undefined,
          resubmitBy: '',
          resubmitNotes: '',
          resubmitFile: '',
          resubmitDate: undefined,
          resubmitBy2: '',
          resubmitNotes2: '',
          resubmitFile2: '',
          resubmitDate2: undefined,
          resubmitBy3: '',
          resubmitNotes3: '',
          resubmitFile3: '',
          resubmitDate3: undefined,
          status: 'Discarded'
        }
        this.props.handleUpdateSectionSubjectDetails(data,id);
      }
    }
  }

  handleInputChange = (e, { name, value }) => {
    this.setState({[name]: value})
  }

  render() {
    const status = this.props.sectionSubjectDetail.status;
    let content, actionButtons;
    if (status === 'To Do' || status === 'Discarded') {
      content = (
        <div>
          <strong>Attach grade sheet:</strong>
          <FileInput
            handleFileChange={this.props.handleUploadFileChange}
            className='grades-file-input'
            error={this.state.error}
          />
          <Form>
            <strong>Notes:</strong>
            <Form.Field error={this.state.error}>
              <TextArea
                name = "notes"
                onChange = {this.handleInputChange}
                rows = {4}
               />
            </Form.Field>
          </Form>
        </div>
      )
      actionButtons = (
        <Button
          positive
          icon='checkmark'
          labelPosition='right'
          content='Submit'
          onClick={this.handleUpdate}
        />
      )
    } else if(status === 'Created') {
      content = (
        <div>
          {this.renderPaceLink()}
          <strong>Grade Sheet/s: </strong>
          <br/>
          {
            this.props.sectionSubjectDetail.file === '' ? '---' :

            <span>1st Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.file)}>{
              this.props.sectionSubjectDetail.file
            }</a> <br/></span>
          }
          {
            this.props.sectionSubjectDetail.resubmitFile === '' ? '---' :
            <span>2nd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile)}>{
              this.props.sectionSubjectDetail.resubmitFile
            }</a> <br/></span>
          }
          {
            this.props.sectionSubjectDetail.resubmitFile2 === ''? '---' :
            <span>3rd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile2)}>{
              this.props.sectionSubjectDetail.resubmitFile2
            }</a> <br/></span>
          }
          {
            this.props.sectionSubjectDetail.resubmitFile3 === ''? '---' :
            <span>4th Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile3)}>{
              this.props.sectionSubjectDetail.resubmitFile3
            }</a> <br/></span>
          }
          <br/>
          <Form>
            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionSubjectDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionSubjectDetail.notes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.sectionSubjectDetail.resubmitBy &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy2 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy2}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes2}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy3 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy3}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes3}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }
            {
              this.props.userType === 'admin' || this.props.userType === 'levelHead' ?
              <span>
                <strong>Level Head Notes:</strong>
                <Form.Field error={this.state.error}>
                  <TextArea
                    name = "levelHeadNotes"
                    onChange = {this.handleInputChange}
                    rows = {4}
                   />
                </Form.Field>
              </span> :
              null
            }
          </Form>
        </div>
      )

      actionButtons = (
        <div>
          {
            this.props.userType === 'admin' || this.props.userType === 'levelHead' ?
            <span><Button
              positive
              icon='checkmark'
              labelPosition='right'
              content='Submit'
              onClick={this.handleUpdate}
            />
            <Button
              negative
              icon='trash'
              labelPosition='right'
              content='Discard'
              onClick={this.handleOpenDiscard}
            /> </span>:
            <span>
              {
                this.props.sectionSubjectDetail.resubmitCount != null ?
                  this.props.sectionSubjectDetail.resubmitCount < 4 ?
                  <Button
                    positive
                    icon='refresh'
                    labelPosition='right'
                    content='Resubmit Grade'
                    onClick={this.handleResubmit}
                  /> : null :
                  <Button
                    positive
                    icon='refresh'
                    labelPosition='right'
                    content='Resubmit Grade'
                    onClick={this.handleResubmit}
                  />
              }
            </span>
          }
        </div>
      )

    } else if(status === 'Checked') {
      content = (
        <div>
          {this.renderPaceLink()}
          <strong>Grade Sheet/s: </strong>
          <br/>
            {
              this.props.sectionSubjectDetail.file === '' ? '---' :

              <span>1st Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.file)}>{
                this.props.sectionSubjectDetail.file
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile === '' ? '---' :
              <span>2nd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile)}>{
                this.props.sectionSubjectDetail.resubmitFile
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile2 === ''? '---' :
              <span>3rd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile2)}>{
                this.props.sectionSubjectDetail.resubmitFile2
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile3 === ''? '---' :
              <span>4th Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile3)}>{
                this.props.sectionSubjectDetail.resubmitFile3
              }</a> <br/></span>
            }
          <br/>
          <Form>
            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionSubjectDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionSubjectDetail.notes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.sectionSubjectDetail.resubmitBy &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy2 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy2}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes2}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy3 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy3}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes3}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }
            <strong>Level Head Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Checked by {this.props.sectionSubjectDetail.checkedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "levelHeadNotes"
                disabled
                value={this.props.sectionSubjectDetail.levelHeadNotes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.userType === 'admin' || this.props.userType === 'registrar' ?
              <span>
                <strong>Registrar Notes:</strong>
                <Form.Field error={this.state.error}>
                  <TextArea
                    name = "registrarNotes"
                    onChange = {this.handleInputChange}
                    rows = {4}
                   />
                </Form.Field>
              </span> : null
            }
          </Form>
        </div>
      )

      actionButtons = (
        <div>
          {
            this.props.userType === 'admin' || this.props.userType === 'registrar' ?
            <span><Button
              positive
              icon='checkmark'
              labelPosition='right'
              content='Submit'
              onClick={this.handleUpdate}
            />
            <Button
              negative
              icon='trash'
              labelPosition='right'
              content='Discard'
              onClick={this.handleOpenDiscard}
            /> </span> :
            <span>
              {
                this.props.sectionSubjectDetail.resubmitCount != null ?
                  this.props.sectionSubjectDetail.resubmitCount < 4 ?
                  <Button
                    positive
                    icon='refresh'
                    labelPosition='right'
                    content='Resubmit Grade'
                    onClick={this.handleResubmit}
                  /> : null :
                  <Button
                    positive
                    icon='refresh'
                    labelPosition='right'
                    content='Resubmit Grade'
                    onClick={this.handleResubmit}
                  />
              }
            </span>
          }
        </div>
      )

    } else if(status === 'Reviewed') {
      content = (
        <div>
          {this.renderPaceLink()}
          <strong>Grade Sheet/s: </strong>
          <br/>
            {
              this.props.sectionSubjectDetail.file === '' ? '---' :

              <span>1st Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.file)}>{
                this.props.sectionSubjectDetail.file
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile === '' ? '---' :
              <span>2nd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile)}>{
                this.props.sectionSubjectDetail.resubmitFile
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile2 === ''? '---' :
              <span>3rd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile2)}>{
                this.props.sectionSubjectDetail.resubmitFile2
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile3 === ''? '---' :
              <span>4th Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile3)}>{
                this.props.sectionSubjectDetail.resubmitFile3
              }</a> <br/></span>
            }
          <br/>
          <Form>
            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionSubjectDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionSubjectDetail.notes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.sectionSubjectDetail.resubmitBy &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy2 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy2}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes2}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy3 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy3}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes3}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }
            <strong>Level Head Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Checked by {this.props.sectionSubjectDetail.checkedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "levelHeadNotes"
                disabled
                value={this.props.sectionSubjectDetail.levelHeadNotes}
                rows = {4}
               />
            </Form.Field>
            <strong>Registrar Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Reviewed by {this.props.sectionSubjectDetail.reviewedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "registrarNotes"
                disabled
                value={this.props.sectionSubjectDetail.registrarNotes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.userType === 'admin' || this.props.userType === 'principal' ?
              <span>
                <strong>Principal Notes:</strong>
                <Form.Field error={this.state.error}>
                  <TextArea
                    name = "principalNotes"
                    onChange = {this.handleInputChange}
                    rows = {4}
                   />
                </Form.Field>
              </span> :
              null
            }
          </Form>
        </div>
      )

      actionButtons = (
        <div>
          {
            this.props.userType === 'admin' || this.props.userType === 'principal' ?
            <span><Button
              positive
              icon='checkmark'
              labelPosition='right'
              content='Submit'
              onClick={this.handleUpdate}
            />
            <Button
              negative
              icon='trash'
              labelPosition='right'
              content='Discard'
              onClick={this.handleOpenDiscard}
            /> </span> :
            <span>
              {
                this.props.sectionSubjectDetail.resubmitCount != null ?
                  this.props.sectionSubjectDetail.resubmitCount < 4 ?
                  <Button
                    positive
                    icon='refresh'
                    labelPosition='right'
                    content='Resubmit Grade'
                    onClick={this.handleResubmit}
                  /> : null :
                  <Button
                    positive
                    icon='refresh'
                    labelPosition='right'
                    content='Resubmit Grade'
                    onClick={this.handleResubmit}
                  />
              }
            </span>
          }
        </div>
      )
    } else if(status === 'Approved') {
      content = (
        <div>
          {this.renderPaceLink()}
          <strong>Grade Sheet/s: </strong>
          <br/>
            {
              this.props.sectionSubjectDetail.file === '' ? '---' :

              <span>1st Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.file)}>{
                this.props.sectionSubjectDetail.file
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile === '' ? '---' :
              <span>2nd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile)}>{
                this.props.sectionSubjectDetail.resubmitFile
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile2 === ''? '---' :
              <span>3rd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile2)}>{
                this.props.sectionSubjectDetail.resubmitFile2
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile3 === ''? '---' :
              <span>4th Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile3)}>{
                this.props.sectionSubjectDetail.resubmitFile3
              }</a> <br/></span>
            }
          <br/>
          <Form>
            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionSubjectDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionSubjectDetail.notes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.sectionSubjectDetail.resubmitBy &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy2 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy2}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes2}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy3 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy3}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes3}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }
            <strong>Level Head Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Checked by {this.props.sectionSubjectDetail.checkedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "levelHeadNotes"
                disabled
                value={this.props.sectionSubjectDetail.levelHeadNotes}
                rows = {4}
               />
            </Form.Field>
            <strong>Registrar Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Reviewed by {this.props.sectionSubjectDetail.reviewedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "registrarNotes"
                disabled
                value={this.props.sectionSubjectDetail.registrarNotes}
                rows = {4}
               />
            </Form.Field>
            <strong>Principal Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Approved by {this.props.sectionSubjectDetail.approvedBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "principalNotes"
                disabled
                value={this.props.sectionSubjectDetail.principalNotes}
                rows = {4}
               />
            </Form.Field>
          </Form>
        </div>
      )
      actionButtons = (
        <span>
          {
            this.props.sectionSubjectDetail.resubmitCount != null ?
              this.props.sectionSubjectDetail.resubmitCount < 4 ?
              <Button
                positive
                icon='refresh'
                labelPosition='right'
                content='Resubmit Grade'
                onClick={this.handleResubmit}
              /> : null :
              <Button
                positive
                icon='refresh'
                labelPosition='right'
                content='Resubmit Grade'
                onClick={this.handleResubmit}
              />
          }
        </span>
      );
    } else if(status === 'Resubmit'){
      content = (
        <div>
          {this.renderPaceLink()}
          <strong>Grade Sheet/s: </strong>
          <br/>
            {
              this.props.sectionSubjectDetail.file === '' ? '---' :

              <span>1st Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.file)}>{
                this.props.sectionSubjectDetail.file
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile === '' ? '---' :
              <span>2nd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile)}>{
                this.props.sectionSubjectDetail.resubmitFile
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile2 === ''? '---' :
              <span>3rd Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile2)}>{
                this.props.sectionSubjectDetail.resubmitFile2
              }</a> <br/></span>
            }
            {
              this.props.sectionSubjectDetail.resubmitFile3 === ''? '---' :
              <span>4th Submission: <a href={gradeSheetLink(this.props.sectionCode, this.props.sectionSubjectDetail.resubmitFile3)}>{
                this.props.sectionSubjectDetail.resubmitFile3
              }</a> <br/></span>
            }
          <br/>
          <Form>

            <strong>Notes:</strong>
            <Label horizontal className='grades-notes-label'>
              Created by {this.props.sectionSubjectDetail.createdBy}
            </Label>
            <Form.Field>
              <TextArea
                name = "notes"
                disabled
                value={this.props.sectionSubjectDetail.notes}
                rows = {4}
               />
            </Form.Field>
            {
              this.props.sectionSubjectDetail.checkedBy &&
              <div>
                <strong>Level Head Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Checked by {this.props.sectionSubjectDetail.checkedBy}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "levelHeadNotes"
                    disabled
                    value={this.props.sectionSubjectDetail.levelHeadNotes}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }
            {
              this.props.sectionSubjectDetail.approvedBy &&
              <div>
                <strong>Registrar Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Reviewed by {this.props.sectionSubjectDetail.approvedBy}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "registrarNotes"
                    disabled
                    value={this.props.sectionSubjectDetail.registrarNotes}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.reviewedBy &&
              <div>
                <strong>Principal Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Approved by {this.props.sectionSubjectDetail.reviewedBy}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "principalNotes"
                    disabled
                    value={this.props.sectionSubjectDetail.principalNotes}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }
            {
              this.props.sectionSubjectDetail.resubmitBy &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy2 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy2}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes2}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            {
              this.props.sectionSubjectDetail.resubmitBy3 &&
              <div>
                <strong>Notes:</strong>
                <Label horizontal className='grades-notes-label'>
                  Resubmitted by {this.props.sectionSubjectDetail.resubmitBy3}
                </Label>
                <Form.Field>
                  <TextArea
                    name = "notes"
                    disabled
                    value={this.props.sectionSubjectDetail.resubmitNotes3}
                    rows = {4}
                   />
                </Form.Field>
              </div>
            }

            <div>
              <strong>Attach new grade sheet:</strong>
              <FileInput
                handleFileChange={this.props.handleUploadFileChange}
                className='grades-file-input'
                error={this.state.error}
              />
              <Form>
                <strong>Notes:</strong>
                <Form.Field error={this.state.error}>
                  <TextArea
                    name = "notes"
                    onChange = {this.handleInputChange}
                    rows = {4}
                   />
                </Form.Field>
              </Form>
            </div>
          </Form>
        </div>
      )
      actionButtons = (
        <Button
          positive
          icon='checkmark'
          labelPosition='right'
          content='Submit'
          onClick={this.handleUpdate}
        />
      )
    } else {
      content = (
        <h3> Invalid Status </h3>
      )
    }
    return (
      <Modal
        trigger={
          <Button color='blue' floated='right' onClick={this.props.handleApprovalOpen}>
            Go To Approval Process
          </Button>
        }
        open={this.props.open}
        onClose={this.handleClose}
        closeIcon
      >
        <Modal.Header>Grades Approval</Modal.Header>
        <Modal.Content>
          {
            this.state.error ?
            <Message
              error
              header="Errors"
              list={[
                'Required fields cannot be empty',
              ]}
            /> :
            null
          }
          <div>
            {content}
          </div>
        </Modal.Content>
        <Modal.Actions>
          {actionButtons}
        </Modal.Actions>
          <Modal
            open={this.state.modalOpen}
            onClose={this.handleCloseDiscard}
            closeIcon
            size='small'
          >
            <Modal.Content>
              {
                this.state.errorDiscard ?
                <Message
                  error
                  header="Errors"
                  list={[
                    'Required fields cannot be empty',
                  ]}
                /> :
                null
              }
              <Form>
                <strong>Discard Notes:</strong>
                <Form.Field error={this.state.errorDiscard}>
                  <TextArea
                    name = "discardNotes"
                    onChange = {this.handleInputChange}
                    rows = {4}
                   />
                </Form.Field>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button color='orange' onClick={this.handleDiscard}>
                <Icon name='trash' /> Discard
              </Button>
            </Modal.Actions>
          </Modal>

          {/* Blank slots are a warning, not a barrier - see submitWithPaceCheck. */}
          <Modal
            open={!!this.state.paceConfirm}
            onClose={this.handleCancelPaceConfirm}
            closeIcon
            size='small'
          >
            <Modal.Header>The PACE form is not complete</Modal.Header>
            <Modal.Content>
              {this.state.paceConfirm && (
                <div>
                  <p>
                    <strong>
                      {(this.state.paceConfirm.total - this.state.paceConfirm.filled).toLocaleString()}
                      {' of '}
                      {this.state.paceConfirm.total.toLocaleString()}
                    </strong>
                    {' ratings are still blank across '}
                    {this.state.paceConfirm.learners} learners.
                  </p>
                  <p>
                    A blank means the competency has not been reached yet, which is a
                    normal way to end a term - so this is only a check, not a block.
                    Submitting sends the grades up for checking and freezes the PACE
                    form until it comes back.
                  </p>
                </div>
              )}
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={this.handleCancelPaceConfirm}>
                Go back
              </Button>
              <Button color='green' onClick={this.handleConfirmPaceSubmit}>
                <Icon name='checkmark' /> Submit anyway
              </Button>
            </Modal.Actions>
          </Modal>
      </Modal>
    )
  }
};

export default GradesApproval;
